import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { PatientProfile } from '../../contracts';
import type {
  SuggestedMatchCandidates,
  SuggestedPatientMatch,
} from './suggested-matches';
import { toSuggestedPatientMatches } from './utils/to-suggested-patient-matches';

export function useSuggestedPatientMatches(
  candidates: SuggestedMatchCandidates | null | undefined,
  patientProfiles: readonly PatientProfile[] | null | undefined
): readonly SuggestedPatientMatch[] {
  const intl = useIntl();

  return useMemo(
    () => toSuggestedPatientMatches(candidates, patientProfiles, intl),
    [candidates, intl, patientProfiles]
  );
}
